import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useOccConfig } from '../../context/occ/hooks/use-occ-config';
import { AutoCompleteType } from '../../subcomponents/form/auto-complete-type';
import { FieldSkeleton } from '../../subcomponents/form/field/field/subcomponents/skeleton';
import { InputField } from '../../subcomponents/form/field/input/input-field';
import { getFieldClassName, getFieldId } from '../../subcomponents/form/field/utils/field-attribute-utils';
import { InvalidFieldNameError } from '../../types/invalid-field-name-error';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { CustomerDetailsFormContextInstance } from '../customer-details-form/types/context';
import { CustomerDetailsFormFieldName } from './types/name';
import { customerDetailsFormFieldPropsValidator, defaultCustomerDetailsFormFieldPropsProvider } from './types/props';
const b = bemClassBuilder('v-customer-details-form-field');
const CustomerDetailsFormField = observer(props => {
    const { enableSkeletonLoadingIndicators } = useOccConfig();
    const { displayText } = props;
    const { onChange, validator, validationConfig, validationResult, disabled, loading, formData } = useContext(CustomerDetailsFormContextInstance);
    if (loading) {
        return enableSkeletonLoadingIndicators ? _jsx(FieldSkeleton, { showLabel: !!displayText.label }) : null;
    }
    const getCommonFieldProps = (key) => ({
        id: getFieldId(b, key),
        name: key,
        className: getFieldClassName(b, key),
        value: formData[key],
        error: validationResult.validationErrors[key],
        disabled,
        validationConfig: validationConfig[key],
        displayText,
        validate: (newValue) => validator.validateField(key, newValue),
        onChangeValue: (newValue) => onChange(key, newValue)
    });
    switch (props.name) {
        case CustomerDetailsFormFieldName.Email:
            return (_jsx(InputField, Object.assign({}, getCommonFieldProps('email'), { type: "email", autoCompleteType: AutoCompleteType.Email })));
        case CustomerDetailsFormFieldName.FamilyName:
            return (_jsx(InputField, Object.assign({}, getCommonFieldProps('familyName'), { type: "text", autoCompleteType: AutoCompleteType.FamilyName })));
        case CustomerDetailsFormFieldName.GivenName:
            return (_jsx(InputField, Object.assign({}, getCommonFieldProps('givenName'), { type: "text", autoCompleteType: AutoCompleteType.GivenName })));
        case CustomerDetailsFormFieldName.PhoneNumber:
            return (_jsx(InputField, Object.assign({}, getCommonFieldProps('phoneNumber'), { type: "tel", autoCompleteType: AutoCompleteType.Tel })));
        default:
            throw new InvalidFieldNameError('CustomerDetailsFormField', props.name);
    }
});
CustomerDetailsFormField.displayName = 'CustomerDetailsFormField';
export const CustomerDetailsFormFieldComponent = withComponentWrapper(CustomerDetailsFormField, defaultCustomerDetailsFormFieldPropsProvider, customerDetailsFormFieldPropsValidator);
